import mockRoleValues from './roles';
import { RolesPermissionsStoreFacade as RolesPermissionStore } from './roles-permissions.facade';
import { RolesPermissionsModule } from './roles-permissions.module';

export { RolesPermissionStore, RolesPermissionsModule, mockRoleValues };

